import { render } from "./fournisseur.vue?vue&type=template&id=afbe8df2&scoped=true"
import script from "./fournisseur.vue?vue&type=script&lang=js"
export * from "./fournisseur.vue?vue&type=script&lang=js"

import "./fournisseur.vue?vue&type=style&index=0&id=afbe8df2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbe8df2"]])

export default __exports__